import { useState } from 'react';
import API from '../api';

export default function Login({ onLogin }) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const { data } = await API.post('/login', { email, password });
      localStorage.setItem('token',  data.token);
      localStorage.setItem('nombre', data.nombre);
      localStorage.setItem('rol',    data.rol || '');
      localStorage.setItem('permisos', JSON.stringify(data.permisos || []));
      localStorage.setItem('login_at', String(Date.now()));
      onLogin({ token: data.token, nombre: data.nombre, rol: data.rol || '', permisos: data.permisos || [] });
    } catch {
      setError('Correo o contraseña incorrectos');
    } finally { setLoading(false); }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#08293f', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {/* Fondo decorativo */}
      <div style={{ position: 'fixed', inset: 0, background: 'radial-gradient(ellipse at 70% 50%, rgba(0,184,227,0.08) 0%, transparent 60%)', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 380, padding: '0 16px', position: 'relative' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ display: 'inline-flex', alignItems: 'baseline', gap: 6, marginBottom: 8 }}>
            <span style={{ fontSize: 28, fontWeight: 700, color: '#00b8e3', letterSpacing: -2 }}>{'// '}</span>
            <span style={{ fontSize: 24, fontWeight: 600, color: '#fff', letterSpacing: 4 }}>AGE</span>
            <span style={{ fontSize: 13, fontWeight: 300, color: '#b3b3b3', letterSpacing: 4, marginLeft: 2 }}>INFORMÁTICA</span>
          </div>
          <p style={{ fontSize: 11, color: 'rgba(0,184,227,0.7)', letterSpacing: '0.15em', fontWeight: 500, textTransform: 'uppercase' }}>
            Software Contable
          </p>
        </div>

        {/* Card */}
        <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(0,184,227,0.2)', padding: 32 }}>
          <h2 style={{ fontSize: 14, fontWeight: 600, color: '#fff', letterSpacing: '0.06em', marginBottom: 24, textTransform: 'uppercase' }}>
            Acceder
          </h2>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label className="label" style={{ color: '#5a7a8a' }}>Correo electrónico</label>
              <input className="input" type="email" value={email}
                onChange={e => setEmail(e.target.value)} required autoFocus
                style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(0,184,227,0.2)', color: '#fff' }} />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label className="label" style={{ color: '#5a7a8a' }}>Contraseña</label>
              <input className="input" type="password" value={password}
                onChange={e => setPassword(e.target.value)} required
                style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(0,184,227,0.2)', color: '#fff' }} />
            </div>

            {error && (
              <div style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.3)', padding: '10px 12px', marginBottom: 16, fontSize: 13, color: '#f87171' }}>
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} className="btn-primary" style={{ width: '100%', padding: '10px', fontSize: 13, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              {loading ? 'Verificando...' : 'Ingresar'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 11, color: 'rgba(255,255,255,0.2)', letterSpacing: '0.04em' }}>
          ageinformatica.com
        </p>
      </div>
    </div>
  );
}
